export default __webpack_public_path__ + "static/media/triangle.d8185b32.svg";